module.exports = __webpack_public_path__ + "static/sm-post_b-21fdd6eb3a5b481b40523ec40951ba80.png";